export default __webpack_public_path__ + "static/media/tender.d42020a5.png";